import { websiteConfigurations } from '~/config/websiteConfigurations';
import { useReferralStore } from '~/stores/referralStore';

// Function to match the domain with wildcard support
function matchDomain(host) {
  let defaultConfig = null;
  
  for (const [key, config] of Object.entries(websiteConfigurations)) {
    let rule = config.domain;
    
    // Store default configuration for fallback
    if (rule === '*') {
      defaultConfig = config;
      continue;
    }
    
    // First try simple domain matching for *.domain patterns
    if (rule.startsWith('*.')) {
      const baseDomain = rule.substring(2); // Remove '*.' prefix
      if (host === baseDomain || host.endsWith('.' + baseDomain)) {
        return config;
      }
    }
    
    // Use regex as fallback for any pattern including *.domain patterns that didn't match above
    var escapeRegex = (str) => str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
    if (new RegExp("^" + rule.split("*").map(escapeRegex).join(".*") + "$").test(host)) {
      return config;
    }
  }
  
  // Return default configuration if no specific match found
  return defaultConfig;
}

export default defineNuxtRouteMiddleware(async (to, from) => {
  const { $i18n } = useNuxtApp()

  if (process.server) {
    var host = useRequestHeaders()['x-forwarded-host'] ? useRequestHeaders()['x-forwarded-host'].split(':')[0] : useRequestHeaders().host.split(':')[0];
  } else {
    var host = window.location.hostname;
  }
  const configuration = matchDomain(host);
  const store = useWebsiteConfigurationStore();
  store.setWebsiteConfiguration(configuration);
  await $i18n.setLocale(configuration.languageCode);

  // Handle canonical domain redirect (SEO-friendly 301 redirect)
  if (configuration?.canonicalDomain && host !== configuration.canonicalDomain) {
    if (process.server) {
      const event = useRequestEvent();
      const protocol = useRequestHeaders()['x-forwarded-proto'] || 'https';
      const canonicalUrl = `${protocol}://${configuration.canonicalDomain}${to.fullPath}`;
      
      // Set 301 status code for permanent redirect (SEO-friendly)
      event.node.res.statusCode = 301;
      event.node.res.setHeader('Location', canonicalUrl);
      event.node.res.end();
      return;
    } else if (process.client) {
      // Client-side redirect fallback
      const protocol = window.location.protocol;
      const canonicalUrl = `${protocol}//${configuration.canonicalDomain}${to.fullPath}`;
      window.location.replace(canonicalUrl);
      return;
    }
  }

  if (configuration.gtag) {
    const { initialize, gtag } = useGtag();
    initialize(configuration.gtag);
  }

  // Capture referral partner tracking code from UTM parameters
  // utm_source is stored when utm_medium is 'partner_iframe'
  const utmMedium = to.query.utm_medium;
  const utmSource = to.query.utm_source;
  if (utmMedium === 'partner_iframe' && utmSource) {
    const referralStore = useReferralStore();
    referralStore.setPartnerCode(utmSource);
  }

});
